import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ListServerPaginationStateModel, LIST_SERVER_PAGINATION_INITIAL_STATE } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { MasterDataBrief } from '../models';
import { MasterDataListInitialState, MasterDataListLoad } from './master-data-list.actions';
import { MasterDataListService } from './master-data-list.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type MasterDataListStateModel = ListServerPaginationStateModel<MasterDataBrief>;

const initialState: MasterDataListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<MasterDataListStateModel>({
  name: 'masterDataList',
  defaults: initialState,
})
@Injectable()
export class MasterDataListState {
  constructor(public masterDataListService: MasterDataListService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: MasterDataListStateModel): MasterDataListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: MasterDataListStateModel): boolean {
    return state.loaded;
  }

  @Action(MasterDataListLoad)
  getMasterDataList(
    ctx: StateContext<MasterDataListStateModel>,
    { payload }: MasterDataListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.masterDataListService.getMasterDataList(payload).pipe(
      take(1),
      map((value: MasterDataListStateModel) => {
        ctx.patchState({ ...value, loaded: true });
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(MasterDataListInitialState)
  setInitialState(ctx: StateContext<MasterDataListStateModel>): void {
    ctx.setState(initialState);
  }
}
